import axios from "axios";

const baseUrl = "http://localhost:5000"

export const getUserAPI = async (id: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/getUser?_id=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user data", error);
    throw error;
  }
};

export const getUserExpenses = async (id: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/getExpenses?userId=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenses data", error);
    throw error;
  }
};

export const getUserIncome = async (id: string) => {
  try {
    const response = await axios.get(`${baseUrl}/api/getIncome?userId=${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching income data", error);
    throw error;
  }
};
